import React from 'react';
import { NavigationLink } from '../primaryHeader/PrimaryHeader';

export interface SubMenuReducerProps {
  index: number;
  links: NavigationLink[] | null;
  element: HTMLElement | null;
  elementOffset: number;
}

interface SubMenuActionProps {
  data: SubMenuReducerProps;
}

const subMenuReducerInitialState: SubMenuReducerProps = {
  index: -1,
  links: null,
  element: null,
  elementOffset: 0,
};

const subMenuReducer = (state: SubMenuReducerProps, action: SubMenuActionProps) => {
  if (action.data.index === state.index) {
    return {
      index: -1,
      links: null,
      element: null,
      elementOffset: 0,
    };
  }

  return action.data;
};

export const useSubMenu = () => {
  return React.useReducer(subMenuReducer, subMenuReducerInitialState);
};
